import { Box, Button, Container, Flex, Heading, Icon, Stack, Text, useColorModeValue, IconButton } from '@chakra-ui/react'
import { map as m, path } from 'ramda'
import { FcAbout } from 'react-icons/fc';
import { useDecisionsQuery, useInsertDecisionMutation, useUpsertParticipantsMutation } from "../app/api";
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';


const Card = ({ heading, description, icon, href, parts }) => {
/*   const texts = useSelector(path(["ui","ui_texts"]));
  const missing = useSelector(path(["ui","missing"])); */
  return (
    <NavLink to={href}>
      <Box w={{base: 300}} minHeight={200} borderWidth="1px" 
        borderRadius="lg" overflow="hidden" boxShadow={"sm"} _hover={{ boxShadow: "md" }} p={5}>

        <Stack align={'start'} spacing={2}>
          <Box mt={2}>
            <Heading size="md">{heading}</Heading>
            <Text mt={1} fontSize={'sm'}>
              {description}
            </Text>
          </Box>
          <Stack overflow="auto" width="100%" direction="row" align="start" spacing={2}>
            {/* process visualization
            {m(x => 
              <Stack direction="column" align="start" className="part" spacing={2} p={2}>
                <Text fontWeight={"bold"} fontSize={'sm'} flexWrap={'nowrap'}>{x.name}</Text>
                <Box borderWidth="2px" w="full" borderRadius="md" borderColor={"black"} overflow={"hidden"}>
                  <Stack direction="" align="center" justifyContent={"center"} spacing={1}>
                  {m(y => <Box p={2} bg={y.is_private ?  "gray.200" : "white"}>
                    <img width="30px" src={`/icons/${y.type}.png`}></img>
                    <Text fontSize={'xs'}>{y.name}</Text>
                  </Box>,x.activities_with_types)}
                  </Stack>
                </Box>
              </Stack>, parts || [])} */}
          </Stack>
        </Stack>
    </Box>
  </NavLink>
  ) 
}

export default function Decisions() {
  const session = useSelector(path(["ui","session"]));
  const {data} = useDecisionsQuery({email:session?.user?.email});

  return (
    <Box p={4}>
      <Container maxW={'5xl'} mt={20}>
        <Flex flexWrap="wrap" gridGap={6} justify="center">
          {m(x => <Card 
            heading={x.name}
            key={x.id}
            // parts={x.decision_types?.parts} for process visual
            // icon={<Icon as={FcAbout} w={10} h={10} />} 
            description={x.description}
            href={('/app/'+x.id)
          }/>,data || [])}
        </Flex>
      </Container>
    </Box>
  )
}